import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ItemNumberToFilterShared } from '../../../models/interface/itemNumberToFilter.interface';

@Component({
  selector: 'app-mu-form-dropdown-country',
  templateUrl: './mu-form-dropdown-country.component.html',
  styleUrls: ['./mu-form-dropdown-country.component.sass'],
})
export class MuFormDropdownCountryComponent {
  @Input() formData: UntypedFormGroup;
  @Input() controlName: string;
  @Input() optionList: ItemNumberToFilterShared;

  constructor() {
    /** */
  }
}
